import { environment } from "../../../../../../../environments/environment";

const BASE_API_URL = environment.ApiUrl + "api/"; // env.apiGateWayAdmin;

export const SMS_REPORT_ENDPOINTS = {
    list: `${BASE_API_URL}sendo-messaging/reports/sms/campaigns`,

    error_list:
        BASE_API_URL + "sendo-messaging/reports/sms/campaignDetail/{id}/errors",
    getReportsCampaignDetailed:
        BASE_API_URL + "sendo-messaging/reports/sms/campaignDetail/{id}",

    getSummaryCampaignDetails:
        BASE_API_URL +
        "sendo-messaging/reports/sms/campaignDetail/summary/{id}",

    getsmsApiReport: BASE_API_URL + "sendo-messaging/reports/sms/api",
    getSmsApiReportExcel:
        BASE_API_URL + "sendo-messaging/reports/sms/api/excel",
    genSmsApiReportExcel: 
    environment.ApiUrl + "reporting/sms/excel",
};
